import { connect } from 'react-redux';

const mapStateToProps = state => {
  return {
    outerLeftCollapsed: state.restricted.shell.layout.outerLeft.collapsed,
  };
};

export default function(Component) {
  return connect(
    mapStateToProps,
    null
  )(Component);
}



// WEBPACK FOOTER //
// ./src/connectHOCs/layoutOuterLeftCollapsed.js